import { Box, Button, ButtonGroup, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const Admin = () => {
  const [slugOption, setSlugOption] = useState('byEmailDomain')
  const [slugArg, setSlugArg] = useState('')
  const [showSlugOptions, setShowSlugOptions] = useState(false)
  const navigate = useNavigate()
  return (
    <Box sx={{ textAlign: 'left' }}>
      <ButtonGroup>
        <Button onClick={() => navigate(`/admin/config/regular`)}>Manage Config</Button>
        <Button onClick={() => navigate(`/admin/users`)}>Manage Users</Button>
        <Button onClick={() => setShowSlugOptions(!showSlugOptions)}>View Slugs</Button>
        <Button onClick={() => navigate(`/admin/config/lite`)}>Manage Config Lite</Button>
        {/* <Button onClick={() => navigate(`/admin/clearcache`)}>Clear Cache</Button> */}
        <Button onClick={() => navigate(`/admin/managecache`)}>Manage Cache</Button>
        <Button onClick={() => navigate(`/admin/orgs`)}>Manage Orgs</Button>
        <Button onClick={() => navigate(`/admin/stripe`)}>Manage Stripe</Button>
      </ButtonGroup>
      {showSlugOptions && <Box sx={{ textAlign: 'left', marginTop: 4, padding: 2 }} boxShadow={1}>
        <FormControl>
          <FormLabel>Slug Options</FormLabel>
          <RadioGroup aria-label="Slug Options" name="Slug Options" value={slugOption} onChange={(e) => {
            setSlugOption(e.target.value)
          }}>
            <FormControlLabel value="byEmailDomain" control={<Radio />} label="By Email Domain" />
            <FormControlLabel value="byEmail" control={<Radio />} label="By Email" />
          </RadioGroup>
        </FormControl>
        <FormControl sx={{ display: 'block' }}>
          <TextField id="ip-slug-arg" label="Argument" variant="outlined" onChange={(e) => setSlugArg(e.target.value)} />
        </FormControl>
        <Button sx={{ marginTop: 1 }} onClick={() => navigate(`/admin/slugs/${slugOption}/${slugArg}`)} variant='contained'>Go</Button>
      </Box>}
    </Box>
  )
}

export default Admin